/* eslint-disable camelcase */
import { put, call, select } from 'redux-saga/effects';
import { push } from 'redux-first-history';
import * as types from '../../constants/ActionTypes';
import Api from '../../functions/Api';
import { convertErrorsFromDjango } from './usersConstants';

export function* selectSubcategory({ payload }) {
  try {
    const subcategoriesSelected = yield select((state) =>
      state.user.subcategoriesSelected.map((i) => i.id)
    );

    const { data } = yield call(Api.put, 'v2/authors/', {
      data: {
        subcategories: [...subcategoriesSelected, payload.id],
      },
    });

    if (data && data.userId) {
      yield put({
        type: types.SEND_PART_USER_INFO_SUCCESS,
        payload: data,
      });
      yield put({
        type: types.GET_SENDED_INFO,
      });
    }
  } catch (error) {
    yield put({
      type: types.SEND_USER_INFO_FAILURE,
      errors: error.response
        ? convertErrorsFromDjango(error.response.errors)
        : {},
      error,
    });
    yield put({ type: types.NETWORK_ERROR, error });
  }
}

export function* deleteSubcategory(action) {
  try {
    const subcategoriesSelected = yield select((state) =>
      state.user.subcategoriesSelected
        .filter((i) => i.id !== action.id)
        .map((i) => i.id)
    );

    const { data } = yield call(Api.put, 'v2/authors/', {
      data: {
        subcategories: [...subcategoriesSelected],
      },
    });

    if (data && data.userId) {
      yield put({
        type: types.SEND_PART_USER_INFO_SUCCESS,
        payload: data,
      });
      yield put({
        type: types.GET_SENDED_INFO,
      });
    }
  } catch (error) {
    yield put({
      type: types.SEND_USER_INFO_FAILURE,
      errors: error.response
        ? convertErrorsFromDjango(error.response.errors)
        : {},
      error,
    });
    yield put({ type: types.NETWORK_ERROR, error });
  }
}

export function* selectLanguage({ payload }) {
  try {
    const languagesSelected = yield select((state) =>
      state.user.languagesSelected.map((i) => i.id)
    );

    const { data } = yield call(Api.put, 'v2/authors/', {
      data: {
        languages: [...languagesSelected, payload.id],
      },
    });

    if (data && data.userId) {
      yield put({
        type: types.SEND_PART_USER_INFO_SUCCESS,
        payload: data,
      });
      yield put({
        type: types.GET_SENDED_INFO,
      });
    }
  } catch (error) {
    yield put({
      type: types.SEND_USER_INFO_FAILURE,
      errors: error.response
        ? convertErrorsFromDjango(error.response.errors)
        : {},
      error,
    });
    yield put({ type: types.NETWORK_ERROR, error });
  }
}

export function* deleteSelectedLanguage(action) {
  try {
    const languagesSelected = yield select((state) =>
      state.user.languagesSelected
        .filter((i) => i.id !== action.id)
        .map((i) => i.id)
    );

    const { data } = yield call(Api.put, 'v2/authors/', {
      data: {
        languages: [...languagesSelected],
      },
    });

    if (data && data.userId) {
      yield put({
        type: types.SEND_PART_USER_INFO_SUCCESS,
        payload: data,
      });
      yield put({
        type: types.GET_SENDED_INFO,
      });
    }
  } catch (error) {
    yield put({
      type: types.SEND_USER_INFO_FAILURE,
      errors: error.response
        ? convertErrorsFromDjango(error.response.errors)
        : {},
      error,
    });
    yield put({ type: types.NETWORK_ERROR, error });
  }
}

export function* sendUserInfo({ payload, redirect }) {
  try {
    const { data } = yield call(Api.put, 'v2/authors/', {
      data: { ...payload },
    });

    if (redirect) {
      if (data && data.userId) {
        yield put({ type: types.SEND_USER_INFO_SUCCESS, data });
      }
      // The author is signed in already (store session) — open the Studio
      try {
        window.location.assign('/my/');
      } catch (e) {
        // Safe navigation in JSDOM/test environment without relative navigation support
      }
    } else if (data && data.userId) {
      yield put({
        type: types.SEND_PART_USER_INFO_SUCCESS,
        payload: data,
      });
      yield put({ type: types.GET_SENDED_INFO });
    }
  } catch (error) {
    yield put({
      type: types.SEND_USER_INFO_FAILURE,
      errors: error.response
        ? convertErrorsFromDjango(error.response.errors)
        : {},
      error,
    });
    yield put({ type: types.NETWORK_ERROR, error });
  }
}

export function* receiveUserInfo(action) {
  try {
    const { data } = yield call(Api.get, 'v2/authors/', {
      locale: action.locale,
    });

    yield put({
      type: types.RECEIVE_USER_INFO_SUCCESS,
      payload: data,
    });
    yield put({
      type: types.GET_SENDED_INFO,
    });
  } catch (error) {
    yield put({
      type: types.RECEIVE_USER_INFO_FAILURE,
      errors: error.response
        ? convertErrorsFromDjango(error.response.errors)
        : {},
      error,
    });
    yield put({ type: types.NETWORK_ERROR, error });
  }
}

export function* signup({
  payload: { phone, first_name, last_name, locale, ...payloadData },
}) {
  try {
    const { data } = yield call(Api.post, 'signup/authors/', {
      data: {
        phone,
        first_name,
        last_name,
      },
      locale,
    });

    if (data?.id) {
      if (payloadData.languages || payloadData.cities) {
        // Send the selected languages and cities IDs
        yield call(sendUserInfo, {
          payload: {
            languages: payloadData.languages.map(({ id }) => id),
            tourCities: payloadData.cities.map(({ id }) => id),
            userId: data.id,
          },
          redirect: true,
          locale,
        });
      }

      // Count sign up success only if `id` has presented in the response
      yield put({
        type: types.SIGNUP_SUCCESS,
        data,
      });
    }
  } catch (error) {
    yield put({
      type: types.SIGNUP_FAILURE,
      errors: error.response
        ? convertErrorsFromDjango(error.response.errors)
        : {},
      error,
    });
    yield put({ type: types.NETWORK_ERROR, error });
  }
}

export function* requestCategories(action) {
  try {
    const { data } = yield call(Api.get, 'v2/categories/', {
      locale: action.locale,
    });

    yield put({
      type: types.RECEIVE_CATEGORIES,
      data,
    });
  } catch (error) {
    yield put({
      type: types.NOT_RECEIVE_CATEGORIES,
      errors: error.response
        ? convertErrorsFromDjango(error.response.errors)
        : {},
      error,
    });
    yield put({ type: types.NETWORK_ERROR, error });
  }
}

export function* redirectAuthors({ payload }) {
  const { phone, isPartner } = payload;

  const pathname = yield select((state) => state.router.location.pathname);
  const partner = yield select((state) => state.partner);
  const { data: { bio = '' } = {} } = partner;

  if (pathname.indexOf('authors/onboarding') === -1) {
    return;
  }

  if (isPartner && phone && bio) {
    yield put(push('/authors/onboarding/done'));
  }
}
